<template>
  <button
    class="custom-pink-add-button"
    :class="{
      underline: underlined,
    }"
    type="button"
    @click="handleBtnClick"
  >
    <img v-if="!removePlus" src="../../icons/dod/dodAddPlusIcon.svg" alt="" />
    <span>{{ title }}</span>
  </button>
</template>

<script>
export default {
  props: ["title", "underlined", "removePlus"],
  emits: ["click"],
  methods: {
    handleBtnClick() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped>
.custom-pink-add-button {
  display: flex;
  gap: 10px;
  font-size: 20px;
  font-weight: 400;
  color: #e2037e;
  border: unset;
  background-color: transparent;
  align-items: center;
  padding: 0 !important;
  margin: 0 !important;
}
.underline {
  border-bottom: 1px solid #e2037e;
}
</style>
